<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

@for (column of matrix; track column; let columnIndex = $index; let isFirstColumn = $first) {
  <div class="flex-column">
    @for (row of column; track row; let rowIndex = $index) {
      <app-claim-progress-step
        [isFinalStep]="lastCompletedStep.column === columnIndex && lastCompletedStep.row === rowIndex"
        [isFinalStepColumn]="lastCompletedStep.column === columnIndex"
        [isStart]="isFirstColumn"
        [model]="row"
      [tooltipToggle]="tooltipToggle"></app-claim-progress-step>
    }
    @if (lastCompletedStep.column === columnIndex) {
      <app-claim-progress-marker [isError]="lastCompletedStep.row === 1"
        [tooltipPlacement]="tooltipPlacement()"
        [tooltipMessage]="matrix[lastCompletedStep.column][lastCompletedStep.row].tooltip"
        [tooltipTitle]="getTooltipCompleteTitle(matrix[lastCompletedStep.column][lastCompletedStep.row])"
      [tooltipToggle]="tooltipToggle"></app-claim-progress-marker>
    }
  </div>
}
